import { render } from "./comunicaciones_form_multiasistencia_old.vue?vue&type=template&id=6ca3a77a"
import script from "./comunicaciones_form_multiasistencia_old.vue?vue&type=script&lang=js"
export * from "./comunicaciones_form_multiasistencia_old.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__